import script from "./BetRange.vue?vue&type=script&setup=true&lang=js"
export * from "./BetRange.vue?vue&type=script&setup=true&lang=js"

import "./BetRange.vue?vue&type=style&index=0&id=3d901c0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d901c0d"]])

export default __exports__